<template>
    <div class="mt-5" style="padding: 0 5%;" color="success">
        <h5 class="text-dark text-left">Biblioteca Digital</h5>
        <hr style="background-color: #000;">
        <v-tabs v-model="tab">
            <v-tab @click="search = ''" v-for="tab in items " :key="tab.tab">{{ tab.tab }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
                <v-card flat class="p-2">
                    <div class="row mt-4">
                        <div class="col-12 col-lg-9">
                            <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Buscar ' + categoryName"
                                hide-details rounded outlined single-line class="mb-5" color="primary"
                                style="width: 100%;"></v-text-field>
                        </div>
                        <div class="col-12 col-lg-3">
                            <v-btn color="primary" style="height: 50px; width: 100%;" @click="addNewResoruce()">
                                <i class="fas fa-plus" style="margin-right: 10px;"></i>
                                Agregar nuevo {{ categoryName === 'Manuales' ? 'manual' : categoryName === 'Videos' ?
                                    'video' :
                                    'artículo' }}
                            </v-btn>
                        </div>

                    </div>
                    <v-card class="mt-2">
                        <v-card-title class="bg-dark text-white" style="display: flex; justify-content: center;">
                            {{ item.tab.charAt(0).toUpperCase() + item.tab.slice(1) }}
                        </v-card-title>
                        <v-data-table :headers="headers" :items="filteredResources" :search="search">
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon @click="gotToEdition(item)" x-large color="primary"> <i
                                        class="fas fa-edit"></i></v-btn>
                                <v-btn icon @click="openDialogDelete(item)" x-large color="primary"><i
                                        class="fas fa-trash-alt"></i></v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <!-- Dialog eliminar -->
        <v-dialog v-model="dialog" persistent max-width="450">
            <v-card>
                <v-card-title class="text-h5" style="display: flex; justify-content: center;">
                    Eliminar
                </v-card-title>
                <v-card-text>¿Seguro que deseas eliminar <strong> {{ currentDocument && currentDocument.titulo }}</strong> ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined text @click="dialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" elevation="2" @click="deleteItem" :loading="isLoading">
                        Eliminar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import router from '@/router';
import axios from 'axios';
const ruteBibliotecaDigital = "/api/BibliotecaDigital/BibliotecaDigital";

export default {
    data() {
        return {
            tab: 0,
            dialog: false,
            dialogInsUpdate: false,
            items: [],
            search: '',
            headers: [
                {
                    text: 'Título',
                    align: 'start',
                    sortable: true,
                    value: 'titulo',
                },
                { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
            ],
            videos: [],
            articules: [],
            manuals: [],

            isModeEdition: false,
            isLoading: false
        }
    },
    async mounted() {
        const { data } = await axios(ruteBibliotecaDigital + '/ObtenerBibliotecaDigital')
        const { manuales, videos, post } = data.data
        const categorias = Object.keys(data.data).map(categoria => ({ tab: categoria == 'post' ? 'Artículos' : categoria }));

        this.items = categorias

        this.videos = videos
        this.articules = post
        this.manuals = manuales

    },
    methods: {

        addNewResoruce() {
            const structure = {}
            //cerar lógica para genera una estrctura con propiedades pero vacia para cada caso 
            this.$store.commit('setCurrentDocument', structure);

            this.$store.commit('setEditionResource', false);

            this.$store.commit('setCategoryName', this.categoryName)
            this.$router.push({ name: 'EdicionRecurso' })
        },
        gotToEdition(item) {
            this.$store.commit('setCurrentDocument', item);
            this.$store.commit('setEditionResource', true);
            this.$store.commit('setCategoryName', this.categoryName)
            this.dialogInsUpdate = true;
            router.push({
                name: 'EdicionRecurso',
            })
        },
        openDialogDelete(item) {
            this.$store.commit('setCurrentDocument', item);
            this.$store.commit('setCategoryName', this.categoryName)
            this.dialog = true;
        },
        async deleteItem() {
            this.isLoading = true;
            try {
                await axios.post(ruteBibliotecaDigital + '/EliminarContenido?ContenidoId=' + this.currentDocument.id)
                const { data } = await axios(ruteBibliotecaDigital + '/ObtenerBibliotecaDigital')
                const { manuales, videos, post } = data.data
                this.videos = videos
                this.articules = post
                this.manuals = manuales

                this.dialog = false
            } catch (error) {
                console.log(error)
            } finally {
                this.isLoading = false
            }

        },
    },
    computed: {
        filteredResources() {
            let resources = [];
            if (this.tab == '0') resources = this.manuals;
            else if (this.tab == '1') resources = this.articules;
            else if (this.tab == '2') resources = this.videos;
            else return
            if (resources.length > 0)
                return resources.sort((a, b) => new Date(b.fechaModificacion) - new Date(a.fechaModificacion));

            return resources;
        },
        categoryName() {
            return this.tab == 0 ? 'Manuales' : this.tab == 1 ? 'Articulos' : this.tab == 2 ? 'Videos' : ''
        },
        currentDocument() {
            return this.$store.state.currentDocument;
        },
    }

}
</script>

<style lang="scss" scoped></style>